<template>
  <DragPanel
    title="属性"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div
      class="tab-box"
      v-if="isHeaderTabVisible">
      <div
        :class="`item-box ${activeTab === 'basic' ? 'active' : ''}`"
        @click="switchTab('basic')">
        基础属性
      </div>
      <div
        :class="`item-box ${activeTab === 'extend' ? 'active' : ''}`"
        @click="switchTab('extend')">
        扩展属性
      </div>
    </div>
    <div
      class="params-box"
      v-show="activeTab === 'basic'">
      <ParamTypeSelect
        v-if="isParamTypeSelectVisible()"
        :paramTypeList="paramTypeList"
        :handleParamTypeChange="handleParamTypeChange" />
      <div
        v-if="isVectorParamsVisible()"
        class="vector-params-box">
        <div
          v-for="(item, index) in vectorParamsData"
          :key="index"
          class="item-box">
          <div class="label-box">{{ item.key }}</div>
          <div class="value-box">{{ item.value }}</div>
        </div>
      </div>
      <ParamsDetail
        v-else
        key="basicParams"
        :elemInfo="elemInfo"
        :paramsData="basicParams" />
    </div>
    <div
      class="params-box"
      v-show="activeTab === 'extend'">
      <ParamsDetail
        v-if="extendParams.length"
        :elemInfo="elemInfo"
        :paramsData="extendParams"
        key="extendParams" />
      <bj-empty
        v-else
        class="empty-page">
        <template>
          <div
            class="empty-text"
            v-if="isChecked('Project.Single.SceneViewPort.Operate')">
            <span>当前构件暂无扩展属性，您可以点击</span>
            <span class="bold-text-box">添加扩展属性</span>
            <span>新增。</span>
          </div>
          <div
            v-else
            class="empty-text">
            当前构件暂无扩展属性
          </div>
        </template>
      </bj-empty>
    </div>
    <div
      class="operation-btn-box"
      v-if="isAddExtendParamsBtnVisible">
      <el-button
        class="primary-btn"
        size="small"
        @click="openAddParamsDialog">
        添加扩展属性
      </el-button>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import ParamTypeSelect from './ParamTypeSelect.vue'
import ParamsDetail from './ParamsDetail.vue'

import { Store } from '@/utils/store'

import {
  getProjectParam,
  getElemParamService,
  getElemParamTypeService,
  getVectorAttrService,
  getRvtGroupByElemIdService,
  getRvtGroupAttrService
} from '@/service/interface'

export default {
  data() {
    return {
      isHeaderTabVisible: false,
      activeTab: 'basic',
      paramTypeList: [],
      basicParams: [],
      extendParams: [],
      vectorParamsData: []
    }
  },
  props: {
    elemInfo: Object,
    closeParamsPanel: Function,
    openAddextendParamsDialog: Function
  },
  components: {
    DragPanel,
    ParamTypeSelect,
    ParamsDetail
  },
  watch: {
    elemInfo: function (newVal, oldVal) {
      if (newVal.elemId !== oldVal.elemId) {
        this.initAttrData()
      }
    }
  },
  computed: {
    isAddExtendParamsBtnVisible() {
      const routePath = this.$route.path
      return (
        this.activeTab === 'extend' &&
        !routePath.includes('panoramicDisplay') &&
        this.isChecked('Developer.BaseQuery')
      )
    }
  },
  mounted() {
    if (Object.keys(this.elemInfo).length) {
      this.initAttrData()
    }
  },
  methods: {
    initAttrData() {
      this.basicParams = []
      this.extendParams = []

      let { elemId, elemType, dataSetType, isRvtGroupMode } = this.elemInfo
      if (!elemId) {
        this.activeTab = 'basic'
        this.isHeaderTabVisible = false
        return
      }

      if (elemType === 'BIMElem' && dataSetType === 0 && !isRvtGroupMode) {
        this.isHeaderTabVisible = true
      } else {
        this.isHeaderTabVisible = false
      }

      if (elemType === 'BIMElem') {
        this.activeTab = 'basic'
        this.queryBIMElemAttr()
        return
      }

      if (elemType === 'ShapeElem') {
        this.activeTab = 'basic'
        this.queryVectorParams()
      }
    },
    switchTab(tabName) {
      this.activeTab = tabName
    },
    openAddParamsDialog() {
      let find = this.basicParams.find(item => item.paramGroup === '构件信息')

      let elemName = ''
      if (find) {
        let paramDatas = find.paramDatas
        let findElemName = paramDatas.find(
          item => item.paramName === '构件名称'
        )
        elemName = findElemName.paramValue
      }

      let findFileInfo = this.basicParams.find(
        item => item.paramGroup === '文件信息'
      )

      let fileName = ''
      if (findFileInfo) {
        let paramDatas = findFileInfo.paramDatas
        let findFileName = paramDatas.find(
          item => item.paramName === '文件名称'
        )
        fileName = findFileName.paramValue
      }

      this.openAddextendParamsDialog(fileName, elemName)
    },
    refreshParams() {
      this.queryModelElemAttr()
    },
    queryBIMElemAttr() {
      let { dataSetType } = this.elemInfo
      if (dataSetType === 0) {
        this.queryModelElemAttr()
      } else {
        this.paramTypeList = []
        this.queryEntityElemAttr()
      }
    },
    async getRvtGroupInfo() {
      let { dataSetId, elemId } = this.elemInfo
      const getGroupIdparams = { dataSetId, elemIntId: elemId }
      const response = await getRvtGroupByElemIdService(getGroupIdparams)
      if (response.isSuccess) {
        return response.data
      } else {
        this.$message.error(response.errMsg)
      }
    },
    async queryModelElemAttr() {
      const { dataSetId, elemId, isRvtGroupMode } = this.elemInfo
      if (isRvtGroupMode) {
        const rvtGroupInfo = await this.getRvtGroupInfo()
        const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
        this.basicParams = attributeData
        return
      }

      let params = { dataSetId, elementIntId: elemId, isQueryExtend: true }
      getProjectParam(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let basicParams = data.elementParamGroups
          this.basicParams = basicParams

          let extendParams = data.extendParams
          this.extendParams = this.formatExtendParams(extendParams)
        } else {
          this.basicParams = []
          this.extendParams = []
          this.$message.error(response.errMsg)
        }
      })
    },
    async getRvtGroupAttr(rvtGroupInfo) {
      if (!rvtGroupInfo) {
        return []
      }
      const { dataSetId } = this.elemInfo
      const groupIntId = rvtGroupInfo?.groupIntId
      const params = { dataSetId, groupIntId }
      const response = await getRvtGroupAttrService(params)
      if (response.isSuccess) {
        const data = response.data
        return data.params
      } else {
        this.$message.error(response.errMsg)
        return []
      }
    },
    formatExtendParams(extendParams) {
      let extendParamsArray = []
      if (extendParams.length) {
        extendParams.forEach(item => {
          let find = extendParamsArray.find(
            el => el.extendParamGroupId === item.extendParamGroupId
          )
          let paramsObj = {
            paramName: item.extendParamName,
            paramValue: item.extendParamValue,
            paramType: item.extendParamType
          }
          if (find) {
            find.paramDatas.push(paramsObj)
          } else {
            let obj = {
              extendParamGroupId: item.extendParamGroupId,
              paramGroup: item.extendParamGroupName
            }
            let paramDatas = []
            paramDatas.push(paramsObj)
            obj.paramDatas = paramDatas
            extendParamsArray.push(obj)
          }
        })
      }

      return extendParamsArray
    },
    queryEntityElemAttr() {
      let { dataSetId, dataSetType, hostFileId, elemId } = this.elemInfo
      let elemParams = { dataSetId, hostFileId }
      getElemParamTypeService(elemParams).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let paramType
          if (data.length) {
            paramType = data[0].paramsType
            this.paramTypeList = data
          } else {
            paramType = 'default'
            this.paramTypeList = [{ paramsId: 'default', paramsType: '默认' }]
          }
          let params = {
            dataSetId,
            dataSetType,
            hostFileId,
            id: elemId,
            paramType
          }
          getElemParamService(params).then(res => {
            if (res.isSuccess) {
              let paramsData = res.data
              paramsData.forEach(item => {
                item['paramGroup'] = item.group
                item['paramDatas'] = item.data
              })
              this.basicParams = paramsData
            } else {
              this.basicParams = []
              this.$message.error(res.errMsg)
            }
          })
        } else {
          let errMsg = response.errMsg
          if (!errMsg.includes('数据操作异常,表')) {
            this.$message.error(errMsg)
          }

          this.paramTypeList = []
        }
      })
    },
    handleParamTypeChange(paramType) {
      this.paramType = paramType
      let { dataSetId, dataSetType, hostFileId, elemId } = this.elemInfo
      let params = {
        dataSetId,
        dataSetType,
        hostFileId,
        id: elemId,
        paramType
      }
      getElemParamService(params).then(response => {
        if (response.isSuccess) {
          let paramsData = response.data
          paramsData.forEach(item => {
            item['paramGroup'] = item.group
            item['paramDatas'] = item.data
          })
          this.basicParams = paramsData
        } else {
          this.basicParams = []
          this.$message.error(response.errMsg)
        }
      })
    },
    queryVectorParams() {
      let { dataSetId, elemId } = this.elemInfo
      let params = { dataSetId, elemId }

      getVectorAttrService(params).then(response => {
        if (response.isSuccess) {
          let vectorParamsData = response.data
          this.vectorParamsData = vectorParamsData
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    isParamTypeSelectVisible() {
      let { dataSetType } = this.elemInfo
      return dataSetType === 19 && this.paramTypeList.length
    },
    isVectorParamsVisible() {
      let { elemType } = this.elemInfo
      return elemType === 'ShapeElem'
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    closePanel() {
      this.closeParamsPanel()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);
  min-width: 300px;

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 16px;
    // background: var(--attr-tabs-bgColor);
    padding-bottom: 16px;

    .tab-box {
      display: flex;
      align-items: center;
      padding: 2px;
      background: var(--attr-tabs-bgColor);
      color: var(--attr-tabs-text-color);
      border-radius: 4px;
      font-size: 14px;
      margin-bottom: 8px;

      .item-box {
        margin: 2px;
        flex: 1;
        padding: 5px;
        cursor: pointer;
        border-radius: 3px;

        &.active {
          color: var(--aside-bg-color);
          background: var(--attr-tabs-active-bgColor);
        }
      }
    }

    .params-box {
      overflow: hidden;
      height: 100%;

      .vector-params-box {
        max-height: 100%;
        font-size: 12px;
        overflow-y: auto;
        border: 1px solid var(--attr-border-color);

        .item-box {
          display: grid;
          grid-template-columns: 1fr 2fr;
          text-align: left;
          border-bottom: 1px solid var(--attr-border-color);

          &:last-child {
            border-bottom: none;
          }

          .label-box {
            word-break: break-all;
            padding: 4px 0px 4px 24px;
            color: var(--collapse-text-label-color);
            border-right: 1px solid var(--attr-border-color);
          }

          .value-box {
            word-break: break-all;
            padding: 4px 4px 4px 8px;
            color: var(--collapse-text-value-color);
          }
        }
      }

      .empty-page {
        height: 100%;

        .bold-text-box {
          font-weight: bold;
          color: var(--page-tips-text-bold-color);
        }
      }
    }

    .operation-btn-box {
      padding: 15px;
      padding-bottom: 0;
      text-align: right;
      border-top: 1px solid var(--dialog-split-line-color);
      width: calc(100% + 30px);
      margin-left: -15px;

      .primary-btn {
        border-radius: 4px;

        &:hover {
          color: var(--aside-bg-color);
          background: var(--base-bg-light-color40);
        }

        &:active {
          color: var(--aside-bg-color);
          background: var(--base-bg-light-color40);
        }

        &:focus {
          color: var(--aside-bg-color);
          background: var(--base-bg-light-color40);
        }
      }
    }
  }
}
</style>
